import { render, staticRenderFns } from "./field-address.vue?vue&type=template&id=72758886&scoped=true"
import script from "./field-address.vue?vue&type=script&lang=js"
export * from "./field-address.vue?vue&type=script&lang=js"
import style0 from "./field-address.vue?vue&type=style&index=0&id=72758886&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72758886",
  null
  
)

export default component.exports